import React from 'react'
import styled, { keyframes } from 'styled-components'
import { usePage } from '../../../contexts'

const LoadingGame = () => {
  const { baseColor } = usePage()

  return (
    <Container>
      <Spinner style={{ borderLeftColor: baseColor }}/>
    </Container>
  )
}

const rotate = keyframes`
  to {
    transform: rotate(360deg);
  }
`

const Container = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  h1 {
    margin-top: 20px;
    font-size: 24px;
  }
`

const Spinner = styled.div`
  border: 8px solid transparent;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: ${rotate} 1s linear infinite;
`

export default LoadingGame
